import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleMappingService {
  constructor(private http: HttpClient) {}

  getMappings(): Observable<any> {
    console.log('Fetching article mappings...');
    return this.http.get(`${environment.SERVER_URL}/news/properties`);

  }
}